import { FvButton } from '@fv/client-components'

import { usePermissions } from '@/features/auth'

import type { RouteGuideView } from './hooks'

type Props = {
  skipToSpot: RouteGuideView['skipToSpot']
  onSkipped?: () => void
}

export const SkipToSpotButton = ({ skipToSpot, onSkipped }: Props) => {
  const { canBook } = usePermissions()
  if (!canBook) return null

  return (
    <FvButton
      theme="default"
      icon="step-forward"
      iconClass="text-fv-orange-bright"
      loading={skipToSpot.isPending}
      onClick={() => skipToSpot.mutate(undefined, { onSuccess: onSkipped })}
    >
      End waterfall and request spot quotes
    </FvButton>
  )
}
